import { Root } from 'react-dom/client';
import App from './App';
import { AddBizReactLoader } from '../../../../../Js/React/loader';
import React from 'react';

let root: Root | undefined;

AddBizReactLoader(root, 'bigregister', () => {
	return <App />;
});
